module.exports = __webpack_public_path__ + "static/media/wMenu2.af841127.png";